/** Kreska wiersza rysuje się na wrapperze, więc komórka wnosi sam odstęp. */
export const cellClass = 'min-w-0 py-[13px]';

/**
 * Łamanie długich ciągów bez spacji (adres e-mail) w kolumnie etykiety
 * i wartości. `wrap-anywhere`, nie `break-words`, bo tylko ono zbija szerokość
 * minimalną komórki — inaczej e-mail rozpycha kolumnę i całą stronę.
 * Kolumna kwoty tego **nie** dostaje: liczba ma się nie łamać.
 */
export const textCellClass = 'wrap-anywhere';

/** Przycisk akcji — jeden wariant kolorystyczny na wszystkie stany wiersza. */
export const actionButtonClass =
  'min-w-[96px] cursor-pointer rounded-[7px] border border-neutral-200 bg-basic-white px-[11px] py-1.5 text-center text-[13px] font-semibold text-neutral-800';
